import * as React from "react";
import { Box, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";

// Components
import Sidebar from "./Sidebar";

export default function Dashboard() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        width: "100vw",
        height: "100vh",
        background: theme.palette.mode === 'dark'
          ? "linear-gradient(135deg, #040509 0%, #141b2d 100%)"
          : "#f8f9fa"
      }}
    >
      <Sidebar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflowX: "hidden",
          overflowY: "auto",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box sx={{ maxWidth: "1600px", margin: "0 auto", padding: { xs: 2, md: 4 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
